import { JustRightHeightModal } from 'components/styled/scoped';
import { Button, Form, Radio, message, Space } from 'antd';
import { useTranslate } from '@tolgee/react';
import { useState } from 'react';
import Icon from '@ant-design/icons';
import { ReactComponent as BatchCloseSvg } from 'assets/icons/batchclose.svg';
import { css } from '@emotion/css';
import { Formik } from 'formik';
import FormField from 'components/FormField';
import { useRequest } from 'ahooks';
import { batchClose } from '../service';

export const BatchClose = (props: { onRefresh: () => void }) => {
  const { t } = useTranslate();
  const [visible, setVisible] = useState(false);
  const title = t('设置自动关闭');
  const { loading, runAsync } = useRequest((data) => batchClose(data), {
    manual: true,
  });

  return (
    <Formik
      initialValues={{
        day: 30,
      }}
      onSubmit={(values) => {
        runAsync({
          day: values.day,
        })
          .then(() => {
            props.onRefresh();
            message.success(t('feedback.已关闭'));
            setVisible(false);
          })
          .catch(() => {
            message.error(t('switch.unCheckedFailed'));
          });
      }}
    >
      {({ handleSubmit }) => {
        return (
          <>
            <JustRightHeightModal
              visible={visible}
              title={title}
              width={354}
              centered
              className={css`
                .ant-modal-body {
                  padding: 10px 16px !important;
                  margin: 0 !important;
                }
              `}
              okButtonProps={{
                loading,
              }}
              onCancel={() => setVisible(false)}
              onOk={() => handleSubmit()}
            >
              <div className="px-[10px] py-[7px] text-[var(--fett-text-secondary)] bg-[var(--fett-surface-error-bg)] leading-[20px] mb-[12px]">
                {t('设置自动关闭后待办状态为已完成，请谨慎操作')}
              </div>
              <Form layout="vertical">
                <FormField
                  name="day"
                  label={t('choose_to_batch_close')}
                  required
                  className={css`
                    .ant-form-item-label > label {
                      color: var(--fett-text-secondary) !important;
                    }
                    .ant-radio-wrapper {
                      color: var(--fett-text-secondary) !important;
                      margin-bottom: 8px;
                      &:last-of-type {
                        margin-bottom: 0;
                      }
                    }
                  `}
                >
                  {({ field }) => {
                    return (
                      <Space direction="vertical">
                        <Radio.Group value={field.value} onChange={field.onChange}>
                          <Radio value={30}>{t('todo_batch_close_day_limit', { x: 30 })}</Radio>
                          <Radio value={15}>{t('todo_batch_close_day_limit', { x: 15 })}</Radio>
                          <Radio value={7}>{t('todo_batch_close_day_limit', { x: 7 })}</Radio>
                        </Radio.Group>
                      </Space>
                    );
                  }}
                </FormField>
              </Form>
            </JustRightHeightModal>
            <Button
              icon={<Icon component={BatchCloseSvg} />}
              type="text"
              onClick={() => setVisible(true)}
            >
              {title}
            </Button>
          </>
        );
      }}
    </Formik>
  );
};
